export default __webpack_public_path__ + "static/media/glass-bead-blasting-icon.fe8945bf.svg";